import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import TextInfo, {
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_COLOR,
  TEXT_SIZE,
} from '@gcloud-npm/components.text';
import CustomLink from '@bitComponents/unifiedComponents/CustomLink';
import Button, {
  BUTTON_COLOR,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
  BUTTON_OPERATION,
} from '@bitComponents/unifiedComponents/Button';
import {
  BUTTON_CONTENT,
  CUSTOM_LINK_CONTENT,
} from '@bitComponents/utils/tagging';
import { STRING_KEYS } from '../../../../localizedStrings';
import InputButtonPlace from '../../../../bitComponents/InputButtonPlace/InputButtonPlace';
import './OTPRequestPin.scss';

const PIN_LENGTH = 6;

const OTPRequestPin = ({
  taggingInfo,
  requestedPinLine,
  handleValidatePinClicked,
  handleRequestPin,
  pinValidationStatus,
}) => {
  const { localizedStrings } = useSelector(state => state.localizedStrings);
  const [pin, setPin] = useState('');
  const {
    validatePinLoading,
    validatePinMismatch,
    validationPinExpired,
  } = pinValidationStatus;

  const pinInputChange = (value) => {
    if (value && Array.isArray(value) && value.length === PIN_LENGTH) {
      const pin = value.join("");
      setPin(pin);
    } else {
      setPin('');
    }
  };

  const onValidatePinClick = () => {
    handleValidatePinClicked(pin);
  };

  const requestedContactText = localizedStrings[STRING_KEYS.registerPersonalData.otpModal.requestedTextSms].replace('{phoneNumber}', requestedPinLine);

  return (
    <div className="otpRequestPinContainer">
      <TextInfo
        className="requesPinText"
        kind={TEXT_KIND.PARAGRAPH}
        color={TEXT_COLOR.GREY4}
        text={requestedContactText}
        size={TEXT_SIZE.TITLE6}
        fontType={TEXT_FONT_WEIGHT.REGULAR}
      />

      <InputButtonPlace onChange={pinInputChange} />

      {validatePinMismatch && (
        <TextInfo
          className="otpPinError"
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.RED_DARK}
          text={localizedStrings[STRING_KEYS.registerPersonalData.otpModal.pinError]}
          size={TEXT_SIZE.TITLE6}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
      )}
      {validationPinExpired && (
        <TextInfo
          className="otpPinError"
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.RED_DARK}
          text={localizedStrings[STRING_KEYS.registerPersonalData.otpModal.pinExpired]}
          size={TEXT_SIZE.TITLE6}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
      )}
      <div className="buttonBoxWrapper">
        <Button
          disable={pin.length !== PIN_LENGTH}
          operation={
            validatePinLoading
              ? BUTTON_OPERATION.LOADING
              : BUTTON_OPERATION.NO
          }
          className="receiveCodeButton"
          onClick={onValidatePinClick}
          color={BUTTON_COLOR.BLUE}
          label={localizedStrings[STRING_KEYS.registerPersonalData.otpModal.validateButton]}
          taggingInfo={{
            ...taggingInfo,
            componentContent: `${BUTTON_CONTENT.DEFAULT}-validar-codigo`,
          }}
          size={{
            w: BUTTON_WIDTH.FULL,
            h: BUTTON_HEIGHT.REGULAR,
          }}
          desktopProps={{
            size: {
              w: BUTTON_WIDTH.MEDIUM,
              h: BUTTON_HEIGHT.REGULAR,
            },
          }}
        />
        <CustomLink
          onClick={handleRequestPin}
          className="newOtp"
          taggingInfo={{
            ...taggingInfo,
            componentContent: `${CUSTOM_LINK_CONTENT.DEFAULT}-recibir-nuevo-codigo`,
          }}
        >
          <TextInfo
            kind={TEXT_KIND.PARAGRAPH}
            text={localizedStrings[STRING_KEYS.registerPersonalData.otpModal.newCodeButton]}
            color={TEXT_COLOR.BLUE_MOVISTAR}
            size={TEXT_SIZE.TITLE6}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </CustomLink>
      </div>
    </div>
  );
};

export default OTPRequestPin;
